import React,  { useEffect } from 'react';

const Loading = ({ image, text }) => {

  return(
    <div className="container loader-container">
      <div className="d-flex flex-column align-items-center">
        <div className="amazon-logo mb-3">
          <img src={image} alt="Amazon" style={{height: "40px"}} />
        </div>
        <div className="spinner-border text-warning" role="status" style={{width: "3rem", height: "3rem"}}>
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="connecting-text">{text}</p>
      </div>
    </div>
  )
};

export default Loading;
